(function () {
  'use strict';

  function initAscendLaunch(root) {
    if (!root || root.dataset.ascendInitialized === 'true') return;
    root.dataset.ascendInitialized = 'true';

    var nav = root.querySelector('[data-ascend-nav]');
    var heroSentinel = root.querySelector('[data-ascend-hero-sentinel]');
    var popupOpenBtns = root.querySelectorAll('[data-ascend-popup-open]');
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var formId = root.getAttribute('data-omnisend-form-id');
    var popupEnabled = root.getAttribute('data-popup-enable') === 'true';
    var autoEnabled = root.getAttribute('data-popup-auto-enable') === 'true';
    var autoDelay = parseInt(root.getAttribute('data-popup-auto-delay'), 10);
    if (isNaN(autoDelay) || autoDelay < 0) autoDelay = 7;

    var autoPopupTimer = null;
    var mysteryTimer = null;

    /* ---------- Nav scroll state ---------- */
    if (nav && heroSentinel && 'IntersectionObserver' in window) {
      var navObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              nav.classList.remove('is-scrolled');
            } else {
              nav.classList.add('is-scrolled');
            }
          });
        },
        { root: null, threshold: 0, rootMargin: '-70px 0px 0px 0px' }
      );
      navObserver.observe(heroSentinel);
    }

    /*
      ---------- Mystery countdown digits ----------
      Purely decorative (aria-hidden): each digit chip quietly reshuffles
      to a fresh "?" on a random interval, giving the topbar a bit of
      life without pretending to count down to a real moment. One digit
      rolls at a time so it stays subtle rather than flashing all eight
      at once.
    */
    var timerRoot = root.querySelector('[data-ascend-timer]');
    if (timerRoot && !prefersReduced) {
      var digitEls = Array.prototype.slice.call(timerRoot.querySelectorAll('[data-timer-digit]'));

      function rollOneDigit() {
        if (!digitEls.length) return;
        var el = digitEls[Math.floor(Math.random() * digitEls.length)];
        var current = el.querySelector('.ascend-launch__timer-digit-inner');
        if (!current) return;

        var next = document.createElement('span');
        next.className = 'ascend-launch__timer-digit-inner ascend-launch__timer-digit-inner--enter';
        next.textContent = '?';
        el.appendChild(next);

        requestAnimationFrame(function () {
          current.classList.add('ascend-launch__timer-digit-inner--exit');
          requestAnimationFrame(function () {
            next.classList.add('ascend-launch__timer-digit-inner--active');
          });
        });

        window.setTimeout(function () {
          if (current.parentNode) current.parentNode.removeChild(current);
        }, 520);
      }

      (function scheduleMysteryRoll() {
        var delay = 700 + Math.random() * 1600;
        mysteryTimer = window.setTimeout(function () {
          rollOneDigit();
          scheduleMysteryRoll();
        }, delay);
      })();
    }

    /*
      ---------- Real Omnisend popup ----------
      The signup modal itself (dark theme, email + phone fields, SMS/email
      consent checkboxes, success screen, Welcome Automation trigger) is
      hosted and rendered entirely by Omnisend, configured to match the
      ASCEND brand reference. This just opens it — there is no local
      modal, no placeholder form, and no fake success state here.
      Omnisend's own script also remembers dismissals across visits.
    */
    function openSignup() {
      if (!formId) {
        console.warn('ASCEND: no Omnisend form ID configured for this section.');
        return;
      }
      if (typeof window.omnisend === 'undefined' || Array.isArray(window.omnisend)) {
        console.warn('ASCEND: Omnisend\'s script does not appear to be loaded on this page yet.');
      }
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['openForm', formId]);
    }

    /*
      ---------- Returning early-access visitors ----------
      After a successful Omnisend signup, Omnisend's own "redirect after
      submission" sends the visitor to the preorder page with ?ea=1, and
      that page stores a first-party flag in this browser. When the flag
      is present, the Early Access button goes straight to the preorder
      page instead of reopening the form.
      This flag is a convenience only. It is NOT proof of SMS consent and
      NOT access control (the preorder page is public by design).
    */
    var preorderUrl = root.getAttribute('data-preorder-url') ||
      (((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'collections/preorder');

    function hasEarlyAccess() {
      try {
        if (window.localStorage.getItem('ascend_early_access')) return true;
      } catch (e) { /* storage unavailable (private mode, blocked) */ }
      return /(?:^|;\s*)ascend_early_access=1/.test(document.cookie);
    }

    function handleCtaClick(event) {
      if (hasEarlyAccess()) {
        event.preventDefault();
        window.location.assign(preorderUrl);
        return;
      }
      openSignup();
    }

    popupOpenBtns.forEach(function (btn) {
      btn.addEventListener('click', handleCtaClick);
    });

    /*
      ---------- Just signed up ----------
      Omnisend dispatches an "omnisendForms" event on window. "submit" fires on the
      first conversion; a multi-step form (email, then SMS) may still be showing a
      later step, so we only remember the signup there and send the visitor to the
      preorder page once the form closes (or 4s after its final step is submitted).
    */
    var justSignedUp = false;
    var redirectTimer = null;
    function rememberSignup() {
      try { window.localStorage.setItem('ascend_early_access', '1'); } catch (e) {}
      document.cookie = 'ascend_early_access=1; path=/; max-age=31536000; SameSite=Lax';
    }
    function goToPreorder() {
      if (redirectTimer) window.clearTimeout(redirectTimer);
      var sep = preorderUrl.indexOf('?') === -1 ? '?' : '&';
      window.location.assign(preorderUrl + sep + 'ea=1');
    }
    function onOmnisendForm(event) {
      var d = event && event.detail;
      if (!d || !d.form) return;
      if (formId && d.form.id && String(d.form.id) !== String(formId)) return;
      if (d.eventName === 'submit' || d.eventName === 'stepSubmit') {
        justSignedUp = true;
        rememberSignup();
        if (redirectTimer) window.clearTimeout(redirectTimer);
        redirectTimer = window.setTimeout(goToPreorder, 4000);
      } else if (d.eventName === 'stepView' && justSignedUp) {
        // another step appeared: give the visitor time to finish it
        if (redirectTimer) window.clearTimeout(redirectTimer);
        redirectTimer = null;
      } else if (d.eventName === 'close' && justSignedUp) {
        goToPreorder();
      }
    }
    window.addEventListener('omnisendForms', onOmnisendForm);

    if (popupEnabled && autoEnabled && !hasEarlyAccess()) {
      autoPopupTimer = window.setTimeout(openSignup, autoDelay * 1000);
    }

    root.__ascendCleanup = function () {
      if (autoPopupTimer) window.clearTimeout(autoPopupTimer);
      if (mysteryTimer) window.clearTimeout(mysteryTimer);
      if (redirectTimer) window.clearTimeout(redirectTimer);
      window.removeEventListener('omnisendForms', onOmnisendForm);
    };
  }

  function initAll() {
    document.querySelectorAll('[data-ascend-launch]').forEach(function (root) {
      initAscendLaunch(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme Editor: re-init cleanly when this section is reloaded */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ascend-launch]');
    if (root) {
      delete root.dataset.ascendInitialized;
      initAscendLaunch(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-ascend-launch]');
    if (root && typeof root.__ascendCleanup === 'function') {
      root.__ascendCleanup();
    }
  });
})();